import Swal from "sweetalert2";
import { FiEdit2 } from "react-icons/fi";
import api from "api";

export default function RequestCustomName({
  request,
  isReadOnly,
  requestId,
  onChange,
}) {
  //if (!request?.frCustomName) return null;

  const canEdit =
    !isReadOnly && request.frStatus === "draft";

  const handleEdit = async () => {
    const result = await Swal.fire({
      title: "Modifier le nom de la demande",
      input: "text",
      inputValue: request.frCustomName,
      inputPlaceholder: "Nom de la demande",
      showCancelButton: true,
      confirmButtonText: "Valider",
      cancelButtonText: "Annuler",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Le nom ne peut pas être vide";
        }
        return null;
      },
    });

    if (!result.isConfirmed) return;

    const newName = result.value.trim();

    if (requestId) {
      const res = await api.put(
        `/formalities/request/${requestId}`,
        { frCustomName: newName }
      );

      if (res?.data?.frCustomName) {
        onChange(res.data.frCustomName);
      }
      return;
    }

    // création (pas encore persistée)
    onChange(newName);
  };

  return (
    <div className="d-flex align-items-center justify-content-center gap-2">

      <span className="fw-semibold">
        {request.frCustomName}
      </span>
      {canEdit && (
        <button
          type="button"
          className="btn btn-link p-0 text-primary"
          onClick={handleEdit}
          aria-label="Modifier le nom"
        >
          <FiEdit2 />
        </button>
      )}
    </div>
  );
}
